import React, { useState } from "react";
import { Nav, NavItem, NavLink, Navbar, NavbarToggler, Button } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";

const menu = [
  { path: "/admin/dashboard", label: "Dashboard" },
  { path: "/admin/books", label: "Books" },
  { path: "/admin/members", label: "Members" },
  { path: "/admin/users", label: "Users" },
  { path: "/admin/rentals", label: "Rentals" },
  { path: "/admin/invoices", label: "Invoices" },
  { path: "/admin/reports", label: "Reports" },
  { path: "/settings", label: "Settings" },
];

const TopNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const toggleNavbar = () => setIsOpen(!isOpen);

  const userData = JSON.parse(sessionStorage.getItem("userData")) || {};
  const menuFiltered = menu.filter((item) => {
    if (userData.branch === "Rehoboth") {
      return item.path !== "/admin/payments" && item.path !== "/admin/members";
    }
    return true;
  });

  const handleLogout = (e) => {
    e.preventDefault();
    sessionStorage.removeItem("userData");
    navigate("/");
  };

  return (
    <Navbar 
      color="white" 
      light 
      className="px-3 py-2 position-relative bg-white border-bottom shadow-sm"
      style={{ zIndex: 1050 }}
    >
      {/* Header Bar Layout rearranged for a left-side hamburger */}
      <div className="d-flex justify-content-start align-items-center w-100 gap-2">
        
        {/* 1. Hamburger Icon sits first on the left */}
        <NavbarToggler onClick={toggleNavbar} className="border-0 px-1" />

        {/* 2. Back Button right next to it */}
        <Button color="secondary" outline size="sm" onClick={() => navigate(-1)} className="ms-1">
          Back
        </Button>

        {/* 3. Branding/Title text */}
        <span className="fw-bold text-dark ms-1">Admin Panel</span>
      </div>

      {/* Floating Dropdown Nav aligned directly under the left-side hamburger */}
      {isOpen && (
        <div 
          className="top-nav-overlay shadow"
          style={{
            position: 'absolute',
            top: '100%',
            left: '12px',       /* Perfectly aligned on the left edge */
            right: 'auto',
            width: 'max-content',
            minWidth: '170px',
            backgroundColor: '#ffffff',
            border: '1px solid #dee2e6',
            borderRadius: '8px',
            padding: '8px',
            zIndex: 1100
          }}
        >
          <Nav vertical className="w-100 flex-column align-items-start">
            {menuFiltered.map((item, index) => (
              <NavItem key={index} className="w-100 m-0">
                <NavLink 
                  tag={Link} 
                  to={item.path} 
                  onClick={() => setIsOpen(false)} 
                  className="text-dark px-3 py-2 rounded item-hover d-block text-start"
                  style={{ whiteSpace: 'nowrap' }}
                >
                  {item.label}
                </NavLink>
              </NavItem>
            ))}
            <hr className="my-2 w-100" />
            <NavItem className="w-100 m-0">
              <NavLink
                href="#"
                onClick={handleLogout}
                className="text-danger px-3 py-2 d-block text-start"
                style={{ whiteSpace: 'nowrap' }}
              >
                Logout
              </NavLink>
            </NavItem>
          </Nav>
        </div>
      )}
    </Navbar>
  );
};

export default TopNavbar;